import userRoute from './users';
import groupRoute from './groups';
import oauthRoutes from './oauth';
import tokenRoute from './tokens';
import approvalRoutes from './approvals';
import messagingRoutes from './messaging';
import settingsRoutes from './settings';

import Main from '@/views/appstructure/Main';
import Dashboard from '@/views/dashboard/Index';
import CloudLogin from '@/views/login/CloudLogin';
import NotFound from '@/views/appstructure/NotFound';

const Audit = () => import(/* webpackChunkName: "audit" */ '@/views/audit/Index');

// Routes spec for Vue router
export default [
  {
    path: '/',
    component: Main,
    children: [
      {
        path: '/',
        name: 'Dashboard',
        component: Dashboard
      },
      userRoute,
      groupRoute,
      tokenRoute,
      approvalRoutes,
      messagingRoutes,
      settingsRoutes,
      {
        path: '/audit',
        component: Audit
      }
    ]
  },
  {
    path: '/login/cloud/:target/:targetType?',
    component: CloudLogin,
    props: true
  },
  ...oauthRoutes,
  {
    path: '*',
    component: NotFound
  }
];
